import React, { useState, useEffect, useContext, useRef } from 'react'
import { DayView, WeekView, MonthView, } from '@devexpress/dx-react-scheduler-material-ui';
import moment from 'moment-timezone';
import { Col, FormControl, InputGroup, Row, Form, Modal, ModalBody, ModalHeader, ModalTitle, ModalFooter } from 'react-bootstrap';
import GlobalContext from '../../GlobalContext';
import ServiceContext from '../../ServiceContext';
import { useImmer } from 'use-immer';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import { RiUserAddLine, RiUserUnfollowLine, RiCheckLine, RiCloseLine, } from 'react-icons/ri'

import TextContext from '../../TextContext';
import CalendarContext from '../../CalendarContext';
import GoodNumber from '../../components/GoodNumber';
import GoodCheck from '../../components/GoodCheck';
import GoodSwitch from '../../components/GoodSwitch';

const addMinutes = (h, add) => {
    return moment(h, 'HH:mm').add(add, 'minute').format('HH:mm')
    const hour = parseInt(h.slice(0, 2))
    const minutes = parseInt(h.slice(3, 5))
    let htoadd = parseInt(add / 60)
    let mtoadd = (add - htoadd * 60) + minutes

    htoadd += hour

    if (mtoadd > 60) {
        htoadd += 1
        mtoadd -= 60
    }

    if (htoadd > 23) {
        htoadd = 23
    }


    const hstring = htoadd.toLocaleString('en-US', {
        minimumIntegerDigits: 2,
        useGrouping: false
    })

    const mstring = mtoadd.toLocaleString('en-US', {
        minimumIntegerDigits: 2,
        useGrouping: false
    })

    return `${hstring}:${mstring}`
}
const checkNumber = (number) => {
    const continuos = number.split(" ").join("")
    //console.log("HEY",continuos)
    return (isInteger(continuos) && continuos.length > 6 && continuos.length < 15)
}
const compTime = (a, b, msg) => {
    const au = moment(a, 'HH:mm').unix()
    const bu = moment(b, 'HH:mm').unix()
    console.log(msg, a, b, au, bu, au > bu)
    return au > bu
}
const isInteger = (number) => {
    if (!/^["|']{0,1}[-]{0,1}\d{0,}(.{0,1}\d+)["|']{0,1}$/.test(number)) return false;
    return !(number - parseInt(number));
}
export const CustomDayTimeTableCell = (props) => {

    const globalContext = useContext(GlobalContext)
    const serviceContext = useContext(ServiceContext)
    const calendarContext = useContext(CalendarContext)
    const textContext = useContext(TextContext)
    const [showAddAlert, pippo] = useState(false)
    const [isAppointment, setIsAppointment] = useState(true)
    const [isOpen, setIsOpen] = useState(false)



    const getPermission = (permission, pos = -1) => {
        if (globalContext.get) {
            if (globalContext.get.User) {
                if (globalContext.get.User.Groups) {
                    if (globalContext.get.User.Groups.length > 0) {
                        if (globalContext.get.User.Groups[0].gro_is_admin) {
                            return true
                        } else {
                            if (pos >= 0) {
                                return parseInt(globalContext.get.User.Groups[0][permission].charAt(pos))
                            } else {
                                return globalContext.get.User.Groups[0][permission]
                            }
                        }
                    }
                }
            }
        }
        return false
    }
    const loadAdd = (pass = false) => {

        let isApt = true
        if (!getPermission('gro_aer_apt', 0)) {
            isApt = false
        }
        if (isOpen || pass) {
            serviceContext.set(draft => {
                draft.addEvent = {
                    cer_date: moment(props.startDate).unix(),
                    cer_apt: isApt
                }
            })
        } else {
            if (!showAddAlert) {
                pippo(true)
            }
        }
    }
    const checkOpen = () => {
        const startHour = moment(props.startDate).format('HH:mm')
        const date = moment(props.startDate).format('YYYY-MM-DD')
        // console.log(calendarContext.get.openDates)
        if (calendarContext.get.openDates[date] && calendarContext.get.openDates[date].includes(startHour)) {
            setIsOpen(true)
        } else {
            setIsOpen(false)
        }

    }
    const closeAddAlert = () => {
        pippo(false)
    }

    useEffect(() => {
    }, [])
    useEffect(() => {
        checkOpen()
    }, [globalContext.get])
    useEffect(() => {
        checkOpen()
    }, [calendarContext.get])


    return (
        <DayView.TimeTableCell
            {...props}
            className={isOpen ? 'open-cell' : 'close-cell'}
            onClick={() => { (getPermission('gro_aer_event', 0) || getPermission('gro_aer_apt', 0)) && loadAdd() }}
        >
            <Modal show={showAddAlert} onHide={closeAddAlert} >
                <ModalHeader closeButton>
                    <ModalTitle className='nac-title'>{textContext.get(['calendar', 'warning'], ['title'], textContext.value)}</ModalTitle>
                </ModalHeader>

                <ModalBody className='' >
                    <Row className='mt-4 mx-3 nac-text light-color'>
                        {textContext.get(['calendar', 'warning'], ['closed'], textContext.value)}
                    </Row>
                </ModalBody>
                <ModalFooter className='d-block'>
                    <Row>
                        <Col xs={3} className='d-flex justify-content-center'>
                            <button type="button" className='nac-button light-color'>
                                <RiCloseLine onClick={closeAddAlert} size={'3vh'} />
                            </button>
                        </Col>
                        <Col xs={6}>
                        </Col>
                        <Col xs={3} className='d-flex justify-content-center'>
                            <button type="button" className='nac-button light-color' >
                                <RiCheckLine onClick={() => { closeAddAlert(); loadAdd(true) }} size={'3vh'} />
                            </button>
                        </Col>
                    </Row>
                </ModalFooter>
            </Modal>
        </DayView.TimeTableCell >
    )
}
export const CustomWeekTimeTableCell = (props) => {

    const globalContext = useContext(GlobalContext)
    const serviceContext = useContext(ServiceContext)
    const calendarContext = useContext(CalendarContext)
    const textContext = useContext(TextContext)
    const [showAddAlert, pippo] = useState(false)
    const [isAppointment, setIsAppointment] = useState(true)
    const [isOpen, setIsOpen] = useState(false)



    const getPermission = (permission, pos = -1) => {
        if (globalContext.get) {
            if (globalContext.get.User) {
                if (globalContext.get.User.Groups) {
                    if (globalContext.get.User.Groups.length > 0) {
                        if (globalContext.get.User.Groups[0].gro_is_admin) {
                            return true
                        } else {
                            if (pos >= 0) {
                                return parseInt(globalContext.get.User.Groups[0][permission].charAt(pos))
                            } else {
                                return globalContext.get.User.Groups[0][permission]
                            }
                        }
                    }
                }
            }
        }
        return false
    }
    const loadAdd = (pass = false) => {

        let isApt = true
        if (!getPermission('gro_aer_apt', 0)) {
            isApt = false
        }
        if (isOpen || pass) {
            serviceContext.set(draft => {
                draft.addEvent = {
                    cer_date: moment(props.startDate).unix(),
                    cer_apt: isApt
                }
            })
        } else {
            if (!showAddAlert) {
                pippo(true)
            }
        }
    }
    const checkOpen = () => {
        const startHour = moment(props.startDate).format('HH:mm')
        const date = moment(props.startDate).format('YYYY-MM-DD')
        // console.log(calendarContext.get.openDates)
        if (calendarContext.get.openDates[date] && calendarContext.get.openDates[date].includes(startHour)) {
            setIsOpen(true)
        } else {
            setIsOpen(false)
        }

    }
    const closeAddAlert = () => {
        pippo(false)
    }

    useEffect(() => {
    }, [])
    useEffect(() => {
        checkOpen()
    }, [globalContext.get])
    useEffect(() => {
        checkOpen()
    }, [calendarContext.get])


    return (
        <WeekView.TimeTableCell
            {...props}
            className={isOpen ? 'open-cell' : 'close-cell'}
            onClick={() => { (getPermission('gro_aer_event', 0) || getPermission('gro_aer_apt', 0)) && loadAdd() }}
        >

            <Modal show={showAddAlert} onHide={closeAddAlert} >
                <ModalHeader closeButton>
                    <ModalTitle className='nac-title'>{textContext.get(['calendar', 'warning'], ['title'], textContext.value)}</ModalTitle>
                </ModalHeader>

                <ModalBody className='' >
                    <Row className='mt-4 mx-3 nac-text light-color'>
                        {textContext.get(['calendar', 'warning'], ['closed'], textContext.value)}
                    </Row>
                </ModalBody>
                <ModalFooter className='d-block'>
                    <Row>
                        <Col xs={3} className='d-flex justify-content-center'>
                            <button type="button" className='nac-button light-color'>
                                <RiCloseLine onClick={closeAddAlert} size={'3vh'} />
                            </button>
                        </Col>
                        <Col xs={6}>
                        </Col>
                        <Col xs={3} className='d-flex justify-content-center'>
                            <button type="button" className='nac-button light-color' >
                                <RiCheckLine onClick={() => { closeAddAlert(); loadAdd(true) }} size={'3vh'} />
                            </button>
                        </Col>
                    </Row>
                </ModalFooter>
            </Modal>
        </WeekView.TimeTableCell >
    )
}
export const CustomMonthTimeTableCell = (props) => {

    const globalContext = useContext(GlobalContext)
    const serviceContext = useContext(ServiceContext)
    const calendarContext = useContext(CalendarContext)
    const textContext = useContext(TextContext)
    const [showAddAlert, pippo] = useState(false)
    const [isAppointment, setIsAppointment] = useState(true)
    const [isOpen, setIsOpen] = useState(false)


    const openWeekView=(date)=>{
        const strDate=moment(date).format('YYYY-MM-DD')
        const time=moment().format('HH:mm')
        calendarContext.set(draft=>{
            draft.currentView=textContext.get(['calendar', 'view_select'], ['week'], textContext.value)
            draft.changeDate=`${strDate}T${time}`
        })
    }
    const getPermission = (permission, pos = -1) => {
        if (globalContext.get) {
            if (globalContext.get.User) {
                if (globalContext.get.User.Groups) {
                    if (globalContext.get.User.Groups.length > 0) {
                        if (globalContext.get.User.Groups[0].gro_is_admin) {
                            return true
                        } else {
                            if (pos >= 0) {
                                return parseInt(globalContext.get.User.Groups[0][permission].charAt(pos))
                            } else {
                                return globalContext.get.User.Groups[0][permission]
                            }
                        }
                    }
                }
            }
        }
        return false
    }
    const loadAdd = (pass = false) => {

        let isApt = true
        if (!getPermission('gro_aer_apt', 0)) {
            isApt = false
        }
        if (isOpen || pass) {
            serviceContext.set(draft => {
                draft.addEvent = {
                    cer_date: moment(props.startDate).unix(),
                    cer_apt: isApt
                }
            })
        } else {
            if (!showAddAlert) {
                pippo(true)
            }
        }
    }
    const checkOpen = () => {
        const startHour = moment(props.startDate).format('HH:mm')
        const date = moment(props.startDate).format('YYYY-MM-DD')
        // console.log(calendarContext.get.openDates)
        if (calendarContext.get.openDates[date] && calendarContext.get.openDates[date].includes(startHour)) {
            setIsOpen(true)
        } else {
            setIsOpen(false)
        }

    }
    const closeAddAlert = () => {
        pippo(false)
    }

    useEffect(() => {
    }, [])
    useEffect(() => {
        checkOpen()
    }, [globalContext.get])
    useEffect(() => {
        checkOpen()
    }, [calendarContext.get])


    return (
        <MonthView.TimeTableCell
            {...props}
            className={isOpen ? 'open-cell' : 'close-cell'}
            onClick={() => { openWeekView(props.startDate) }}
        >
            <Modal show={showAddAlert} onHide={closeAddAlert} >
                <ModalHeader closeButton>
                    <ModalTitle className='nac-title'>{textContext.get(['calendar', 'warning'], ['title'], textContext.value)}</ModalTitle>
                </ModalHeader>

                <ModalBody className='' >
                    <Row className='mt-4 mx-3 nac-text light-color'>
                        {textContext.get(['calendar', 'warning'], ['closed'], textContext.value)}
                    </Row>
                </ModalBody>
                <ModalFooter className='d-block'>
                    <Row>
                        <Col xs={3} className='d-flex justify-content-center'>
                            <button type="button" className='nac-button light-color'>
                                <RiCloseLine onClick={closeAddAlert} size={'3vh'} />
                            </button>
                        </Col>
                        <Col xs={6}>
                        </Col>
                        <Col xs={3} className='d-flex justify-content-center'>
                            <button type="button" className='nac-button light-color' >
                                <RiCheckLine onClick={() => { closeAddAlert(); loadAdd(true) }} size={'3vh'} />
                            </button>
                        </Col>
                    </Row>
                </ModalFooter>
            </Modal>
        </MonthView.TimeTableCell >
    )
}







